export default __webpack_public_path__ + "static/media/segre10.efbc47c5.jpg";